import appConfig from '~/config/app'

import mobileAppApi from './apis/native-app.api'
import {
  FrontendMessage,
  FrontendRequest,
  FrontendRequestType,
  GoogleFrontendReceipt,
  MobileAppResponse,
  MobileAppResponseType,
  PurchaseItem,
  SubscriptionPurchase,
} from './types/native-app.types'

class NativeApp {
  private messageHandler: void
  private purchaseCallBack
  private userId: number

  public constructor() {
    if (!appConfig.isMobileApp) return

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    this.purchaseCallBack = (isValid: boolean, receipt?: GoogleFrontendReceipt) => {}
    if (typeof window !== 'undefined') {
      this.messageHandler = window.addEventListener('message', this.MessageHandler.bind(this), true)
    }
  }

  // Public methods

  public PurchaseItem(item: PurchaseItem, callBack: (isValid: boolean, receipt?: GoogleFrontendReceipt) => void): void {
    this.purchaseCallBack = callBack
    this.sendMessageToApp({ type: FrontendRequestType.Purchase, payload: item })
  }

  public SendMessage(message: FrontendMessage): void {
    this.sendMessageToApp(message)
  }

  // Private methods

  private validateReceipt = async (receipt: SubscriptionPurchase): Promise<void> => {
    try {
      const response = await mobileAppApi.validateReceipt(receipt)
      this.purchaseCallBack(true, response as GoogleFrontendReceipt)
    } catch (err) {
      throw new Error(`Validate Receipt Error: ${err}`)
    }
  }

  private MessageHandler(message: { data: string; origin: string }): void {
    try {
      const response = JSON.parse(message.data) as MobileAppResponse
      if (!response.origin) return

      switch (response.type) {
        case MobileAppResponseType.Purchase_Success:
          this.validateReceipt(response.payload as SubscriptionPurchase)
          break
        case MobileAppResponseType.Purchase_Failed:
          this.purchaseCallBack(false)
          throw new Error(`Purchase Failed: ${response.payload}`)
        case MobileAppResponseType.ReadyPlayerMe:
          window.postMessage(response.payload as string)
          break
        default:
          throw new Error(`Error in message handler `)
          break
      }
    } catch (err) {
      console.error('Error in message handler', err)
    }
  }

  private sendMessageToApp(message: FrontendMessage | FrontendRequest): void {
    if (typeof window !== 'undefined') {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify(message))
      }
    }
  }
}

const nativeApp = new NativeApp()

export default nativeApp
